import "moment/locale/it";

import moment from "moment";

moment.locale("it");

export const createUnixMilliFromLocalDate = (localDate: string): number => {
    return moment(localDate, "YYYY-MM-DD").valueOf();
};

export const createLocalDateFromUnixMilli = (unixMilli: number): string => {
    return moment(unixMilli).format("YYYY-MM-DD");
};

export default moment;
